import { Injectable, OnInit } from "@angular/core";
import { AuthService } from "../services/auth.service";
import { ActivatedRoute, Router } from "@angular/router";

@Injectable({ providedIn: 'root' }) export class ConfigService {
    // companyId;
    active = true;

    companyId;
    companyIds;
    constructor(public auth: AuthService, private route: ActivatedRoute, private router: Router) {

        // this.auth.user$.subscribe(user => this.companyId = user.companyId)
    }


    getCompanyId() {
        if (this.active && !this.companyId)
            this.companyId = this.changeCompanyId()
        return this.companyId//this.auth.getCompanyId()
    }

    changeCompanyId(selectedId?, navigate?) {
        this.companyIds = this.auth.getCompanyId();

        const companyIds = JSON.parse(this.companyIds);

        // If the cuboid id is in list use that
        let companyId = "IbYFkxDI8RbMdRiukALO";

        if (localStorage.getItem('selected-companyId')) {
            companyId = localStorage.getItem('selected-companyId');
        }

        if (selectedId) {
            companyId = selectedId;
        }

        if (!companyIds.includes(companyId)) {
            companyId = companyIds[0];
        }

        if (companyId) {
            localStorage.setItem('selected-companyId', companyId);
        }




        // // Check if there is any company id in the local storage
        // if(localStorage.getItem('selected-companyId') == selectedId) {
        //     console.log('company id in local storage');
        //     companyId = localStorage.getItem('selected-companyId');
        // } else if (selectedId) {
        //     // Save current company id in local storage
        //     localStorage.setItem('selected-companyId', this.companyId);
        // }

        // // Check if company id is not in the list
        // if (!companyIds.includes(companyId)) {
        //     console.log('company id not in list');
        //     companyId = companyIds[0]; // Select first in list
        //     localStorage.setItem('selected-companyId', companyId);
        // }
        // console.log('company id:', companyId);

        if (selectedId) {
            this.companyId = selectedId;
            if (navigate != false) this.navigate()
            return selectedId;
        } else {
            this.companyId = companyId;
            return companyId;
        }
    }


    navigate() {
        this.router.navigate(['dashboard/sites'], { relativeTo: this.route }).then(() => {
            window.location.reload();
        });
        // this.router.navigateByUrl('/RefrshComponent', { skipLocationChange: true })
        // .then(() =>
        //     

        //     ))
    }

    getComapnyIdList() {
        return new Promise((res, rej) => {
            res(JSON.parse(this.auth.getCompanyId()))
        })
    }
}

